"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Divider = _interopRequireDefault(require("./Divider"));
var _useTheme = _interopRequireDefault(require("../../hooks/useTheme"));
const ItinerarySeparator = ({
  children,
  type,
  color
}) => {
  const theme = (0, _useTheme.default)();
  if (children || type) return /*#__PURE__*/React.createElement("div", {
    className: "relative flex w-full justify-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.default)("bg-elevation-flat-border-color absolute inset-x-0 top-1/2 z-10 w-full", type ? "border" : "h-px"),
    style: {
      borderStyle: type,
      borderColor: color && theme.orbit[color]
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "px-50 bg-white-normal relative z-[11] py-0"
  }, children));
  return /*#__PURE__*/React.createElement(_Divider.default, null);
};
var _default = exports.default = ItinerarySeparator;